<div class="estimates-container">
  <div class="estimates-section">
    <ng-container *ngFor="let group of recentEstimateGroups">
      <h3 class="section-heading">{{ group.label | translate }}</h3>
      <ul class="estimates-list">
        <li *ngFor="let estimate of group.estimates; trackBy: trackById" class="estimate-item" [title]="('ESTIMATE_ID' | translate) + ' : ' + estimate.id"
          (click)="onEstimateClick(estimate)">
          <span class="estimate-content row">
            <span class="estimate-icon width-3-5rem">
              <mat-icon>description</mat-icon>
            </span>
            <span class="estimate-details">
              <span class="estimate-name">{{ estimate.name }}</span>
              <span class="estimate-date">{{ estimate.date | multilingualDate: 'dateTime' }}</span>
            </span>
          </span>
          <mat-icon class="star-icon" aria-hidden="false" fontIcon="star_border"
            (click)="moveToFavorite(estimate); $event.stopPropagation()"></mat-icon>
        </li>
      </ul>
    </ng-container>
    <p *ngIf="recentEstimateGroups.length === 0" class="empty-message">{{'NO_RECENT_ESTIMATES' | translate}}</p>

  </div>

  <div class="estimates-section">
    <h2 class="section-heading">{{'FAVORITE' | translate}}</h2>
    <ul class="estimates-list">
      <li *ngFor="let estimate of favoriteEstimates; trackBy: trackById" class="estimate-item favourite-item"
        (click)="onEstimateClick(estimate)">
        <span class="estimate-content row">
          <span class="estimate-icon width-3-5rem">
            <mat-icon>description</mat-icon>
          </span>
          <span class="estimate-details">
            <span class="estimate-name">{{ estimate.name }}</span>
            <span class="estimate-date">{{ estimate.date | multilingualDate: 'dateTime' }}</span>
          </span>
          
        </span>
        <mat-icon class="star-icon filled" aria-hidden="false" fontIcon="star"
          (click)="moveToRecent(estimate); $event.stopPropagation()"></mat-icon>
      </li>
    </ul>
    <p *ngIf="favoriteEstimates.length === 0" class="empty-message">{{'NO_FAVORITE_ESTIMATES' | translate}}</p>
  </div>
</div>